import Constants from './Constants';


import OrdersView from '../views/orders/View';
import TheOrdersView from "../views/orders/TheOrdersView";

export default [
    {
        path : '/orders/',
        name : Constants.ORDERS_INDEX,
        component : TheOrdersView,
        meta : {
            title : 'Orders',
            className : 'exact-height-page-con',
            accessGuard : true,
        }
    },
    {
        path : '/orders/:id',
        name : Constants.ORDERS_VIEW,
        component : OrdersView,
        meta : {
            title : 'Loading Order',
            accessGuard : true,
        }
    }
];
